import type { MarketingPreferencesData } from '../../domain/types'
import { CheckboxField } from '@sunwebgroup/ui-components/uds'
import { Control, Controller, FieldPath } from 'react-hook-form'

interface CheckboxFieldProps {
  name: FieldPath<MarketingPreferencesData>
  control: Control<MarketingPreferencesData>
  label: React.ReactNode
  handleCheckboxGroupValidation?: () => void
}

export const ControlledCheckboxField: React.FC<CheckboxFieldProps> = ({ name, control, label, handleCheckboxGroupValidation }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const { onChange, value, ...rest } = field
        return (
          <CheckboxField
            {...rest}
            checked={Boolean(value)}
            onCheckedChange={(checked) => {
              onChange(checked)
              if (handleCheckboxGroupValidation) {
                handleCheckboxGroupValidation()
              }
            }}
            label={label}
            variant="outlined"
          />
        )
      }}
    />
  )
}
